module.exports = __webpack_public_path__ + "img/p_11.5088b010.png";